import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import api from "../../api";

const ResetPassword = () => {
  const { register, watch, handleSubmit, formState: { errors } } = useForm();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [successMessage, setSuccessMessage] = useState("");
  const [ errorMessage, setErrorMessage ] = useState(null);

  useEffect( () => {
    function checkToken() {
      if ( !token ) {
        window.location.replace('/');
      }
    }

    checkToken();
  }, [] );

  const handleResetPasswordSubmit = ( data ) => {
    api.resetPassword(
      { 
        token                 : token, 
        password              : data.password, 
        password_confirmation : data.confirmPassword 
      },
      (res) => {
        if (res.status === 200) {
          setSuccessMessage("Password has been reset successfully! Redirecting...");
          setTimeout(() => navigate("/"), 3000);
        }
      },
      ( error ) => {
        if ( error.status === 400 ) {
          setErrorMessage(error.response.data.error);
        }
      }
    );
  };

  return (
    <div className="nc-PageResetPassword" data-nc-id="PageResetPassword">
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Reset Password
        </h2>
        <div className="max-w-md mx-auto space-y-6">

          {/* ERROR MESSAGE */}
          {errorMessage && 
            <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
              <p className="font-bold">Error</p>
              <p>{ errorMessage }</p>
            </div>
          }
          {/* ERROR MESSAGE */}

          {/* SUCESS MESSAGE */}
          {successMessage &&
            <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4" role="alert">
              <p className="font-bold">Success</p>
              <p>{ successMessage }</p>
            </div>
          }
          {/* SUCESS MESSAGE */}

          <div className="grid grid-cols-1 gap-6">
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">New Password</span>
              <Input
                type="password"
                name="password"
                placeholder="Enter new password"
                className="mt-1"
                {...register( "password", { 
                  required: "Password field is required", 
                  minLength: {
                    value: 8,
                    message : "Minimum character length is 8"
                  }
                } )}
              />
              {errors.password && 
                <span className="ml-1 mt-2 text-xs text-red-500">
                  {errors.password.message.toString()}
                </span>
              }
            </label>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">Confirm Password</span>
              <Input
                type="password"
                name="confirmPassword"
                placeholder="Confirm new password"
                className="mt-1"
                {...register( "confirmPassword", { 
                  required: "Confirm Password field is required", 
                  validate: (val: string) => {
                    if (watch('password') != val) {
                      return "Your passwords do no match";
                    }
                  },
                } )}
              />
              {errors.confirmPassword && 
                <span className="ml-1 mt-2 text-xs text-red-500">
                  {errors.confirmPassword.message.toString()}
                </span>
              }
            </label>
            <ButtonPrimary onClick={handleSubmit(handleResetPasswordSubmit)}>Reset Password</ButtonPrimary>
          </div>
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            Remember your password? {" "}
            <a href="/login" className="text-blue-500">Sign in</a>
          </span>

        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
